import AnnouncementIcon from '@mui/icons-material/Announcement'
import { ComparisonCellState, ComparisonTableRowProps } from '../../../INSi/comparisonTable/_props'
import { FieldConfig, PatientInsiComparisonValues } from './_props'

export const fullscreenActionDialogValues = {
    title: 'Récupérer les informations INS du patient via le téléservice INSi',
    calloutTitle:
        'En acceptant la mise à jour, les informations actuelles seront remplacées par celles récupérées via le téléservice INSi. Au contraire, pour conserver les données présentes du patient, cliquez sur “annuler”.',
    calloutErrorTitle:
        'Il n’est pas possible de mettre à jour les données du patient, car au moins une des informations récupérée via le téléservice INSi est manquante.',
}

const fieldConfigs: FieldConfig[] = [
    { field: 'birthName', label: 'Nom de naissance' },
    { field: 'firstNameList', label: 'Prénom(s) de naissance' },
    { field: 'birthDate', label: 'Date de naissance' },
    { field: 'sex', label: 'Sexe' },
    { field: 'birthCityCode', label: 'Lieu de naissance', helperText: '(Code INSEE)' },
    { field: 'insNum', label: 'Matricule INS' },
    { field: 'insOid', label: 'OID' },
]

const cellState = (columnIndex: number, isError?: boolean, isEqual?: boolean): ComparisonCellState | undefined => {
    if (columnIndex === 2) {
        if (isError) {
            return 'error'
        }
        return isEqual ? undefined : 'new'
    }

    return isEqual ? undefined : 'previous'
}

export const createComparisonTable = (
    currentValues: PatientInsiComparisonValues,
    newValues: PatientInsiComparisonValues,
): ComparisonTableRowProps[] =>
    fieldConfigs.map(({ field, label, helperText }) => {
        const currentFieldValue =
            currentValues?.[field] instanceof Error ? currentValues?.[field].message : currentValues?.[field]
        const newFieldValue = newValues?.[field] instanceof Error ? newValues?.[field].message : newValues?.[field]
        const isNewFieldError = Boolean(newValues?.[field] instanceof Error)

        let isEqual

        if (currentFieldValue === newFieldValue) {
            isEqual = currentFieldValue?.toLowerCase() === newFieldValue?.toLowerCase()
        }

        return {
            items: [
                { type: 'header', label, helperText },
                {
                    label: currentFieldValue,
                    state: cellState(1, isNewFieldError, isEqual),
                },
                {
                    label: newFieldValue,
                    state: cellState(2, isNewFieldError, isEqual),
                    icon: isNewFieldError && <AnnouncementIcon />,
                },
            ],
        }
    })
